import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTopbar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconLayoutTopbar"><Path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V9L3 9V3.75Z" fill="currentColor"/><Path d="M3 10.5V20.25C3 20.6642 3.33579 21 3.75 21L11.25 21V10.5L3 10.5Z" fill="currentColor"/><Path d="M12.75 21L20.25 21C20.6642 21 21 20.6642 21 20.25V10.5L12.75 10.5V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutTopbar;
